import getActivePage from '../../../helpers/get-active-page';
import linkTypes from '../constants/link-types';
import fieldNames from '../constants/field-names';

const getFallbackFieldsValues = (linkType) => {
  switch (linkType) {
    case linkTypes.PAGE: {
      const activePage = getActivePage();
      return {
        [fieldNames.LINK_TYPE]: linkTypes.PAGE,
        [fieldNames.PAGE_REFERENCE]: (activePage && activePage.id) ?? '',
      };
    }
    default:
      return {};
  }
};

export default getFallbackFieldsValues;
